import { render } from "./CreateLeedForm.vue?vue&type=template&id=1d2a4074&scoped=true"
import script from "./CreateLeedForm.vue?vue&type=script&lang=js"
export * from "./CreateLeedForm.vue?vue&type=script&lang=js"

import "./CreateLeedForm.vue?vue&type=style&index=0&id=1d2a4074&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2a4074"]])

export default __exports__